import { z } from "zod";
import { PREFERRED_SCHEDULE_VALUES } from "@/config/contact";

/**
 * Validación del mini-form de "solicitar llamada": solo contacto y franja.
 *
 * Espeja las reglas del backend: un pedido de llamada no exige email, tipo de
 * negocio ni cantidad.
 */
export const callbackFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, "Escribí tu nombre completo")
    .max(80, "El nombre no puede exceder 80 caracteres"),

  phone: z
    .string()
    .trim()
    .regex(/^\+?[1-9][\d]{0,15}$/, "Ingresá un teléfono válido (ej. +50761568575)"),

  preferredSchedule: z.enum(PREFERRED_SCHEDULE_VALUES, {
    errorMap: () => ({ message: "Elegí una franja horaria" }),
  }),

  /** Honeypot: invisible para las personas, los bots lo completan. */
  website: z.string().optional(),
});

export type CallbackFormValues = z.infer<typeof callbackFormSchema>;